import React from "react"
import { Form, FormFeedback, Toast, ToastBody } from "reactstrap"

import Spinners from "components/Common/Spinner"

import deleteRed from "../../../assets/images/icons/delete-red.svg"
import close from "../../../assets/images/icons/close.svg"
import toast from "react-hot-toast"
import BgPatternImage from "../../../assets/images/background-pattern.png"
import { useFormik } from "formik"
import * as Yup from "yup"

function DeleteConfirmationModal({
  id,
  open,
  setOpen,
  isLoading,
  title = "Delete Item",
  description = "Are you sure you want to delete this item?",
  onDelete,
  onSuccess,
  onClose,
}) {
  const handleDelete = async (values) => {
    try {
      const { success, message } = await onDelete({ ...values }).unwrap()
      if (success) {
        onSuccess()
        toast.success(message, { id: "toastMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { reason: "" },
    validationSchema: Yup.object({
      reason: Yup.string().required("Please Enter Reason for Deletion"),
    }),
    onSubmit: (values) => {
      handleDelete(values)
    },
  })

  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3 delete-tost"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <div className="delete-card-wrapper">
                <div className="delete-wrapper">
                  <img src={deleteRed} alt="" />
                </div>
                <div>
                  <h4>{title}</h4>
                  {description}
                </div>
                <div className="close-icon" onClick={() => setOpen(false)}>
                  <img src={close} alt="" />
                </div>
              </div>

              <div
                className="form-group mt-3"
                style={{ position: "relative", zIndex: 2 }}
              >
                <label htmlFor="rejection-reason">Reason for Deletion</label>
                <textarea
                  name="reason"
                  id="rejection-reason"
                  type="text"
                  className="form-control"
                  rows="3"
                  value={validation.values.reason}
                  onChange={validation.handleChange}
                  placeholder="Enter the reason for deleting the account"
                />
                {validation.errors.reason && (
                  <FormFeedback type="invalid">
                    {validation.errors.reason}
                  </FormFeedback>
                )}
              </div>
              <div className="mt-3 pt-3 button-wrapper position-relative z-2">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="cancel"
                >
                  Cancel
                </button>
                <button type="submit" className="delete">
                  {isLoading ? <Spinners /> : "Delete"}
                </button>
              </div>
            </Form>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default DeleteConfirmationModal
